import { Auth } from "aws-amplify";
import { Box, Button, Header as GrommetHeader, Menu } from "grommet";
import { Menu as MenuIcon } from "grommet-icons";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/User/UserContext";
import { EmsPaths } from "../sidebar/components/paths/EmsPath";
import { PathType } from "../sidebar/components/paths/PathType";
import { Paths as AdminPath } from "../sidebar/components/paths/Path";
import { observer } from "mobx-react";
import { useStore } from "../../../Hooks/useStore";
import { Mixpanel } from "../../../util/Helper";
import { unsubscribeToTopic } from "../../../App";
function Header() {
  const { rootStore } = useStore();
  const navigate = useNavigate();

  const { setUser, user } = useUser();

  const logoutClicked = () => {
    Auth.signOut();
    setUser(null);
    localStorage.removeItem("endpointUrl");
    localStorage.removeItem("auth");
    localStorage.removeItem("p256dh");
    localStorage.removeItem("isRegister");
    localStorage.removeItem("registerEndPointError");
    if(user?.username)
      {
    Mixpanel.track("web_user_logout",{name:user?.username});
      }
    Mixpanel.resetUser();
    unsubscribeToTopic(rootStore);
   
    navigate("");
  };

  useEffect(() => {
    if (user) {
      switch (user["custom:type"]) {
        case "ems":
          rootStore.headerPathStore.setPath(EmsPaths);
          break;
        default:
          rootStore.headerPathStore.setPath(AdminPath);
      }
    }
  }, [user]);

  const menuItems = rootStore.headerPathStore.getPath.map((item) => {
    if (item.subPaths && item.subPaths.length > 0) {
      return item.subPaths.map((subItem) => {
        return {
          label: subItem.label,
          onClick: () => {
            navigate(subItem.path);
          },
        };
      });
    } else {
      return [
        {
          label: item.label,
          onClick: () => {
            navigate(item.path);
          },
        },
      ];
    }
  });

  return (
    <GrommetHeader pad={"small"} background="primary_blue_100">
      <Menu
        label=""
        items={[...menuItems, [{ label: "logout", onClick: logoutClicked }]]}
        icon={<MenuIcon />}
      ></Menu>
    </GrommetHeader>
  );
}

export default observer(Header);
